module.exports = __webpack_public_path__ + "img/icon_calculator.de206e19.png";